export default {

  getInitials(user) {
    if (user == null || user.firstName == null || user.lastName == null) {
      return "";
    }
    return user.firstName.substring(0, 1).toUpperCase() + user.lastName.substring(0, 1).toUpperCase()
  },

  isNotPublic(route) {
    if (route == null) {
      return true; // hidden by default
    }
    return !route.matched.some(record => record.meta.public)
  },

  isAllowed(route, roleToCheck) {
    if (!route || !roleToCheck) {
      return true; // allowed by default
    }
    return route.matched.some(record => {
      if (record.meta.restricted) {
        return record.meta.restricted.some(role => role === roleToCheck)
      } else {
        return true
      }
    })
  },

  isBlank(str) {
    return (!str || /^\s*$/.test(str));
  },

  // Determines if the drag and drop functionality is in the window
  determineDragAndDropCapable() {
    /*
      Create a test element to see if certain events
      are present that let us do drag and drop.
    */
    let div = document.createElement('div');

    /*
      Check to see if the `draggable` event is in the element
      or the `ondragstart` and `ondrop` events are in the element. If
      they are, then we have what we need for dragging and dropping files.

      We also check to see if the window has `FormData` and `FileReader` objects
      present so we can do our AJAX uploading
    */
    return (('draggable' in div)
      || ('ondragstart' in div && 'ondrop' in div))
      && 'FormData' in window
      && 'FileReader' in window;
  },

  disableDragAndDrop(elm) {
    /*
      Listen to all of the drag events and bind an event listener to each.
    */
    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
      /*
        For each event add an event listener that prevents the default action
        (opening the file in the browser) and stop the propagation of the event (so
        no other elements open the file in the browser)
      */
      elm.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
      }.bind(this), false);
    }.bind(this));
  }
}



// WEBPACK FOOTER //
// ./src/services/utils.js